import { CommonModule } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";
import { HelpDialog } from "../../model/dialog/form-dialog";
import { HelpDialogButtonComponent } from "../help-dialog-button/help-dialog-button";
@Component({
  selector: "pax-form-field-label",
  standalone: true,
  imports: [CommonModule, HelpDialogButtonComponent],
  templateUrl: "./form-field-label.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormFieldLabelComponent {
  @Input({ required: true })
  key!: string;

  @Input()
  label: string | undefined;

  @Input()
  subLabel: string | undefined;

  @Input()
  helpDialog: HelpDialog | undefined;

  @Input()
  labelClasses: string | undefined;

  @Output()
  openDialog = new EventEmitter<void>();

  get shouldDisplayDialogToTheRightSideOfTheLabel() {
    if (!this.helpDialog) {
      return false;
    }

    return (
      // For help dialogs without a position we position them as a default to the right
      // side of the label
      !this.helpDialog.position || this.helpDialog.position === "right"
    );
  }
}
